import React from "react";

const WhyFyxme = () => {
    return (
        <section className="ls s-pt-55 s-pt-md-50 s-pb-50 s-pt-lg-100 s-pb-lg-50 service-section text-center text-lg-left c-gutter-0" id="service">
            <div className="container">
                <div className=" col-12 mb-50 text-center">
                    <h4>Why Fyxme? BMW</h4>
                    <div className="divider-60 d-none d-xl-block"></div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-6 col-xl-6">
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/11.png" alt="Save time and Money"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Save Time and Money
                                </h6>
                                <p>
                                    Don’t leave your car at a shop for days. We provide mobile bumper and body repair services at your home or office - 7 days a week, saving you time and money.

                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/06Replacement-Parts.png" alt="replacement parts"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Bumper and Fender Replacement
                                </h6>
                                <p>
                                    If we can’t fix it, we will order bumper replacements and other parts and install them at your location. Front bumper replacement and rear bumper replacement costs vary depending on the make, model, and severity of damage.
                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/10.png" alt="paint car scratch repair"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Paint & Car Scratch Repair
                                </h6>
                                <p>
                                    Our mobile car scratch repair technicians can touch up car paint and fix minor scrapes or deep scratches on car doors, hoods, bumpers, and fenders.
                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/05Paint-Matching.png" alt="paint matchinh"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Industry Best Paint with Lifetime Guarantee
                                </h6>
                                <p>
                                    Our advanced computerized PPG paint color matching and high-quality application system will ensure your original paints color.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-xl-6">
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/07Best-Quality.png" alt="best quality"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Dealership Quality
                                </h6>
                                <p>
                                    We have partnered with the industry’s best suppliers to ensure the tools and products we use achieve the same results you will find anywhere else.
                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/12.png" alt="dent repair"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Dent Repair
                                </h6>
                                <p>
                                    We repair dented hoods, door dings, and bumper and fender dents quickly and affordably, helping to restore your car back to its
                                    original condition.
                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/04Minor-accidents.png" alt="minor accidents"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Minor Accidents, Dents and Scratches
                                </h6>
                                <p>
                                    We fix car and truck fenders and bumpers, scratches on doors, hood and door dents, Paintless Dent Removal (PDR) - almost anything.
                                </p>
                            </div>
                        </div>
                        
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/INSURANCE-ICON-FYXME-3.png" alt="All insurance claims accepted"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    All insurance claims accepted
                                </h6>
                                <p>
                                We can coordinate hassle-free car body repairs with your insurance company. Whether you're filing a claim or paying out of pocket, we will provide a detailed estimate specific to your vehicle's repair needs. 
                                </p>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </section>
    );
}

export default WhyFyxme;